import Translate from "@casino/legacy/client/shared/i18n/Translate";
import Button from "@casino/legacyUi/Button";
import { FormItem } from "@casino/legacyUi/form/FormItem";

type Props = { loading: boolean; disabled: boolean; handleSubmit: () => void };

const SubmitLogin: FC<Props> = ({ loading, disabled, handleSubmit }) => (
  <FormItem>
    <Button
      variant="primary"
      fullWidth
      type="submit"
      onClick={handleSubmit}
      animation={loading ? "progress" : undefined}
      disabled={disabled}
      className="h-10"
    >
      <Translate id="profile.login" />
    </Button>
  </FormItem>
);

export default SubmitLogin;
